"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { rem } from "polished";
import makeStyles from "../../theming/make-styles.js";
import Dialog from "../dialog/index.js";
import { slideInBottom, slideInLeft, slideInRight, slideInTop, slideOutBottom, slideOutLeft, slideOutRight, slideOutTop } from "../utils/css/animation.js";
const slideInByPlacement = {
    top: slideInTop,
    right: slideInRight,
    bottom: slideInBottom,
    left: slideInLeft,
};
const slideOutByPlacement = {
    top: slideOutTop,
    right: slideOutRight,
    bottom: slideOutBottom,
    left: slideOutLeft,
};
const verticalSizes = {
    small: rem(360),
    medium: rem(480),
    large: "none",
};
function placementStyle(placement, size) {
    switch (placement) {
        case "top": {
            return {
                top: 0,
                right: 0,
                left: 0,
                maxWidth: "100vw",
                maxHeight: verticalSizes[size],
                height: "100%",
            };
        }
        case "right": {
            return {
                top: 0,
                right: 0,
                width: "100%",
                height: "100vh",
            };
        }
        case "bottom": {
            return {
                right: 0,
                bottom: 0,
                left: 0,
                maxWidth: "100vw",
                maxHeight: verticalSizes[size],
                height: "100%",
            };
        }
        case "left": {
            return {
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
            };
        }
        default: {
            return {};
        }
    }
}
const useStyles = makeStyles()((theme, { placement, size }) => ({
    drawer: Object.assign(Object.assign({}, placementStyle(placement, size)), { "position": "fixed", "borderRadius": 0, "animation": `${slideInByPlacement[placement]} .3s forwards`, [theme.breakpoints.up("md")]: (placement === "top" || placement === "bottom") &&
            size === "large" && {
            maxHeight: "50%",
        }, "&[class*='animateOut']": {
            animation: `${slideOutByPlacement[placement]} .3s forwards`,
        } }),
}));
export const Drawer = React.forwardRef(function Drawer(_a, ref) {
    var { children, className, open = false, placement = "right", size = "small" } = _a, props = __rest(_a, ["children", "className", "open", "placement", "size"]);
    const { classes, cx } = useStyles({ placement, size });
    return (_jsx(Dialog, Object.assign({ ref: ref, className: cx(classes.drawer, className), "data-component": "drawer", open: open, size: size }, props, { children: children })));
});
export default Drawer;
//# sourceMappingURL=drawer.js.map